module.exports = __webpack_public_path__ + "img/hero_cn.aeafc5d.jpg";